'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import { Modal, type ModalProps } from '@udemy-v2/react-dialog-components';
import { useI18n } from '@udemy-v2/i18n';
import { Button } from '@udemy-v2/react-core-components';
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import classNames from 'classnames';
import { CodingExercisePromotionSeeDemoLinkClickEvent, CodingExercisePromotionDemoVideoImpressionEvent } from './events';
import { MediaPlayerWrapper } from '../media-player/asset-media-player.react-component';
import { useFetchAsset } from '@/lib/hooks/use-fetch-asset';
import styles from './coding-exercise-promotion-modal.module.scss';
interface CodingExercisePromotionModalProps {
  onClose: ModalProps['onClose'];
  isOpen: ModalProps['isOpen'];
  assetId: number;
  assetTitle: string;
  courseId: number;
  trackingId: string;
}
export const CodingExercisePromotionModal = t0 => {
  const $ = _c(18);
  const {
    onClose,
    isOpen,
    assetId,
    assetTitle,
    courseId,
    trackingId
  } = t0;
  const {
    gettext
  } = useI18n();
  const {
    assetVideo
  } = useFetchAsset(isOpen ? assetId : undefined, assetTitle);
  let t1;
  if ($[0] !== courseId || $[1] !== trackingId) {
    t1 = () => {
      publishEvent(new CodingExercisePromotionDemoVideoImpressionEvent({
        id: courseId,
        trackingId
      }));
    };
    $[0] = courseId;
    $[1] = trackingId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trackImpression = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("ud-heading-lg", styles["demo-intro"]);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== gettext) {
    t3 = gettext("Coding Exercises Demo");
    $[4] = gettext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <h2 id="coding-exercise-promotion-modal-title"><span className={t2}>{t3}</span></h2>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== assetVideo) {
    t5 = <div className={styles["video-container"]}><MediaPlayerWrapper asset={assetVideo} /></div>;
    $[8] = assetVideo;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5 || $[11] !== trackImpression) {
    t6 = <TrackImpression trackFunc={trackImpression} visibilityThreshold={0.25}>{t5}</TrackImpression>;
    $[10] = t5;
    $[11] = trackImpression;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isOpen || $[14] !== onClose || $[15] !== t4 || $[16] !== t6) {
    t7 = <Modal className="ud-color-scheme-dark" renderTitle={_temp} title="" isOpen={isOpen} onClose={onClose}>{t4}{t6}</Modal>;
    $[13] = isOpen;
    $[14] = onClose;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
interface CodingExerciseModalTriggerProps {
  assetTitle: string;
  assetId: number;
  courseId: number;
  ctaText: string;
  trackingId: string;
}
export const CodingExerciseModalTrigger = t0 => {
  const $ = _c(16);
  const {
    assetTitle,
    assetId,
    courseId,
    ctaText,
    trackingId
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] !== courseId || $[1] !== trackingId) {
    const trackCodingExerciseSeeDemoLinkClick = () => {
      publishEvent(new CodingExercisePromotionSeeDemoLinkClickEvent({
        id: courseId,
        trackingId
      }));
    };
    t1 = () => {
      trackCodingExerciseSeeDemoLinkClick();
      setIsModalOpen(true);
    };
    $[0] = courseId;
    $[1] = trackingId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleCloseModal = t2;
  let t3;
  if ($[4] !== ctaText || $[5] !== handleOpenModal) {
    t3 = <Button componentClass="a" className={styles["coding-exercise-modal-trigger"]} udStyle="link-underline" typography="ud-text-sm" onClick={handleOpenModal}>{ctaText}</Button>;
    $[4] = ctaText;
    $[5] = handleOpenModal;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== assetId || $[8] !== assetTitle || $[9] !== courseId || $[10] !== isModalOpen || $[11] !== trackingId) {
    t4 = <CodingExercisePromotionModal isOpen={isModalOpen} onClose={handleCloseModal} assetId={assetId} assetTitle={assetTitle} courseId={courseId} trackingId={trackingId} />;
    $[7] = assetId;
    $[8] = assetTitle;
    $[9] = courseId;
    $[10] = isModalOpen;
    $[11] = trackingId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp() {
  return ["title-in-body-modal-title", null];
}